import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateSensitive,
  deleteSensitive,
  getPaySetting,
  getSensitive,
  groupRedEnvelope,
  privateRedEnvelope,
  setPaySetting,
  setSensitive,
  transferMoney,
  operationRecord,
  getSilverCoinDetails,
  versionConfig,
  createVersionConfig,
  updateVerSionConfig,
  deleteVersionConfig,
  getWorldChatAdmin,
  setWorldChatAdmins,
  deleteWorldChatAdmins
} from "@/api/modules/paySetting";

export const getPaySettingAction = createAsyncThunk(
  "todayData/getPaySetting",
  async () => {
    // getUserChannels函数是一个axios的请求
    const result = await getPaySetting();
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getSensitiveAction = createAsyncThunk(
  "todayData/getSensitive",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getSensitive(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const CreateSensitiveAction = createAsyncThunk(
  "todayData/CreateSensitive",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await CreateSensitive(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const setSensitiveAction = createAsyncThunk(
  "todayData/setSensitive",
  async ({ sensitiveWordId, content }: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await setSensitive(sensitiveWordId, { content });
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const deleteSensitiveAction = createAsyncThunk(
  "todayData/deleteSensitive",
  async (list: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await deleteSensitive({ list });
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const setPaySettingAction = createAsyncThunk(
  "todayData/setPaySetting",
  async (data: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await setPaySetting(data);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const groupRedEnvelopeAction = createAsyncThunk(
  "todayData/groupRedEnvelope",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await groupRedEnvelope(params);
    console.log(result);

    return result;
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const privateRedEnvelopeAction = createAsyncThunk(
  "todayData/privateRedEnvelope",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await privateRedEnvelope(params);
    console.log(result);

    return result;
  }
);

// 第一个参数为action，第二个参数为中间件处理的函数，一般用于发送axios请求
export const transferMoneyAction = createAsyncThunk(
  "todayData/transferMoney",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await transferMoney(params);
    console.log(result);

    return result;
  }
);

export const operationRecordAction = createAsyncThunk(
  "paySetting/operationRecord",
  async (params: any) => {
    const result = await operationRecord(params)
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const getSilverCoinDetailsAction = createAsyncThunk(
  "paySetting/getSilverCoinDetails",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getSilverCoinDetails(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const versionConfigAction = createAsyncThunk(
  "versionConfig",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await versionConfig(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const createVersionConfigAction = createAsyncThunk(
  "createVersionConfig",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await createVersionConfig(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)

export const updateVersionConfigAction = createAsyncThunk(
  "updateVersionConfig",
  async ({ versionId, params }: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await updateVerSionConfig(versionId, params);
    if (result.data) return result.data;
  }
)

export const deleteVersionConfigAction = createAsyncThunk(
  "deleteVersionConfig",
  async (versionId: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await deleteVersionConfig(versionId);
    if (result.data) return result.data;
  }
)

export const getWorldChatAdminAction = createAsyncThunk(
  "getWorldChatAdmin",
  async (v) => {
    // getUserChannels函数是一个axios的请求
    const result = await getWorldChatAdmin();
    if (result.data) return result.data;
  }
)

export const setWorldChatAdminsAction = createAsyncThunk(
  "setWorldChatAdmins",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await setWorldChatAdmins(params);
    if (result.data) return result.data;
  }
)

export const deleteWorldChatAdminsAction = createAsyncThunk(
  "deleteWorldChatAdmins",
  async (adminId: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await deleteWorldChatAdmins(adminId);
    if (result.data) return result.data;
  })